// extracted by mini-css-extract-plugin
export default {"fileArea":"attachFile_fileArea__-6hig","listContainer":"attachFile_listContainer__PLEZS","imgArea":"attachFile_imgArea__FYcoe","btnArea":"attachFile_btnArea__WSTjU"};